// Generated by ReScript, PLEASE EDIT WITH CARE


var This = {};

function oneClickConfirmPaymentFn(param, param$1) {
  return Promise.resolve({});
}

function confirmPaymentFn(_elements) {
  return Promise.resolve({});
}

function confirmCardPaymentFn(_clientSecretId, _data, _options) {
  return Promise.resolve({});
}

function retrievePaymentIntentFn(_paymentIntentId) {
  return Promise.resolve({});
}

function update(_options) {
  
}

function getElement(_componentName) {
  
}

function fetchUpdates() {
  return new Promise((function (resolve, param) {
                setTimeout((function () {
                        resolve({});
                      }), 1000);
              }));
}

var fnArgument = (function () {
    return new Promise((function (param, param$1) {
                  
                }));
  });

function defaultPaymentElement_on(_str, _func) {
  
}

function defaultPaymentElement_collapse() {
  
}

function defaultPaymentElement_blur() {
  
}

function defaultPaymentElement_update(_x) {
  
}

function defaultPaymentElement_destroy() {
  
}

function defaultPaymentElement_unmount() {
  
}

function defaultPaymentElement_mount(_string) {
  
}

function defaultPaymentElement_focus() {
  
}

function defaultPaymentElement_clear() {
  
}

function defaultPaymentElement_onSDKHandleClick(_fnArgument) {
  
}

var defaultPaymentElement = {
  on: defaultPaymentElement_on,
  collapse: defaultPaymentElement_collapse,
  blur: defaultPaymentElement_blur,
  update: defaultPaymentElement_update,
  destroy: defaultPaymentElement_destroy,
  unmount: defaultPaymentElement_unmount,
  mount: defaultPaymentElement_mount,
  focus: defaultPaymentElement_focus,
  clear: defaultPaymentElement_clear,
  onSDKHandleClick: defaultPaymentElement_onSDKHandleClick
};

function create(_componentType, _options) {
  return defaultPaymentElement;
}

function defaultElement_updateIntent(param) {
  return Promise.resolve(null);
}

var defaultElement = {
  getElement: getElement,
  update: update,
  fetchUpdates: fetchUpdates,
  create: create,
  updateIntent: defaultElement_updateIntent
};

function getCustomerDefaultSavedPaymentMethodData() {
  return null;
}

function getCustomerLastUsedPaymentMethodData() {
  return null;
}

function confirmWithCustomerDefaultPaymentMethod(_confirmParams) {
  return Promise.resolve({});
}

function confirmWithLastUsedPaymentMethod(_confirmParams) {
  return Promise.resolve({});
}

function defaultGetCustomerSavedPaymentMethods(_options) {
  return Promise.resolve(null);
}

function defaultInitPaymentSession_updateIntent(param) {
  return Promise.resolve(null);
}

var defaultInitPaymentSession = {
  getCustomerSavedPaymentMethods: defaultGetCustomerSavedPaymentMethods,
  updateIntent: defaultInitPaymentSession_updateIntent
};

function defaultInitAuthenticationSession_initClickToPaySession(param) {
  return Promise.resolve(null);
}

function defaultInitAuthenticationSession_getActiveClickToPaySession() {
  return Promise.resolve(null);
}

var defaultInitAuthenticationSession = {
  initClickToPaySession: defaultInitAuthenticationSession_initClickToPaySession,
  getActiveClickToPaySession: defaultInitAuthenticationSession_getActiveClickToPaySession
};

function defaultHyperInstance_elements(_ev) {
  return defaultElement;
}

function defaultHyperInstance_widgets(_ev) {
  return defaultElement;
}

function defaultHyperInstance_paymentRequest(_ev) {
  return null;
}

function defaultHyperInstance_initPaymentSession(_ev) {
  return defaultInitPaymentSession;
}

function defaultHyperInstance_initAuthenticationSession(_ev) {
  return defaultInitAuthenticationSession;
}

function defaultHyperInstance_paymentMethodsManagementElements(_ev) {
  return defaultElement;
}

function defaultHyperInstance_completeUpdateIntent(param) {
  return Promise.resolve({});
}

function defaultHyperInstance_initiateUpdateIntent() {
  return Promise.resolve({});
}

function defaultHyperInstance_confirmTokenization(param) {
  return Promise.resolve({});
}

var defaultHyperInstance = {
  confirmOneClickPayment: oneClickConfirmPaymentFn,
  confirmPayment: confirmPaymentFn,
  elements: defaultHyperInstance_elements,
  confirmCardPayment: confirmCardPaymentFn,
  retrievePaymentIntent: retrievePaymentIntentFn,
  widgets: defaultHyperInstance_widgets,
  paymentRequest: defaultHyperInstance_paymentRequest,
  initPaymentSession: defaultHyperInstance_initPaymentSession,
  initAuthenticationSession: defaultHyperInstance_initAuthenticationSession,
  paymentMethodsManagementElements: defaultHyperInstance_paymentMethodsManagementElements,
  completeUpdateIntent: defaultHyperInstance_completeUpdateIntent,
  initiateUpdateIntent: defaultHyperInstance_initiateUpdateIntent,
  confirmTokenization: defaultHyperInstance_confirmTokenization
};

function eventTypeMapper($$event) {
  switch ($$event) {
    case "blur" :
        return "Blur";
    case "change" :
        return "Change";
    case "clickTriggered" :
        return "Click";
    case "completeDoThis" :
        return "CompleteDoThis";
    case "confirmTriggered" :
        return "ConfirmPayment";
    case "escape" :
        return "Escape";
    case "focus" :
        return "Focus";
    case "oneClickConfirmTriggered" :
        return "OneClickConfirmPayment";
    case "ready" :
        return "Ready";
    default:
      return "None";
  }
}

function getStrFromHyperComponentName(hyperComponentName) {
  if (hyperComponentName === "Elements") {
    return "Elements";
  } else {
    return "PaymentMethodsManagementElements";
  }
}

function getHyperComponentNameFromStr(hyperComponentName) {
  if (hyperComponentName === "PaymentMethodsManagementElements") {
    return "PaymentMethodsManagementElements";
  } else {
    return "Elements";
  }
}

export {
  This ,
  oneClickConfirmPaymentFn ,
  confirmPaymentFn ,
  confirmCardPaymentFn ,
  retrievePaymentIntentFn ,
  update ,
  getElement ,
  fetchUpdates ,
  fnArgument ,
  defaultPaymentElement ,
  create ,
  defaultElement ,
  getCustomerDefaultSavedPaymentMethodData ,
  getCustomerLastUsedPaymentMethodData ,
  confirmWithCustomerDefaultPaymentMethod ,
  confirmWithLastUsedPaymentMethod ,
  defaultGetCustomerSavedPaymentMethods ,
  defaultInitPaymentSession ,
  defaultInitAuthenticationSession ,
  defaultHyperInstance ,
  eventTypeMapper ,
  getStrFromHyperComponentName ,
  getHyperComponentNameFromStr ,
}
/* No side effect */
